/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, useRef } from "react";
import { observer } from "mobx-react";
import { Device } from "@twilio/voice-sdk";
import { toasterState } from "Components/common/toaster";
import { makeApi, URLS } from "Utils/apiURL";
import userDetail from "Stores/userDetail";
import DialerServiceData, {
  defaultDialerOption
} from "Stores/DialerServiceStore";
import { hideIntercomChat } from "Utils/Scripts/intercom";
import ContactInfo from "./DialerContactInfo";
import DialerKeypad from "./DialerKeypad";
import DialerButton from "./DialerButton";
import DialerDefaultNumber from "./DialerDefaultNumber";
import DialerChannelSelector from "./DialerChannelSelector";
import DialerCredits from "./DialerCredits";
import DialerLogsAfterCallEnd from "./DialerLogsAfterCallEnd";
import { dialerLogsPopupState } from "./DialerLogsAfterCallEndPopup";
import DialerUpgradeCreditsPopup from "./DialerUpgradeCreditsPopup";
import DialerButtonLoader from "./DialerButtonLoader";
import { confirmationPopupState } from "Components/common/confirmationPopup";
import Utils from "Utils/utils";
import SliderHeader from "./SliderHeader";
import { callsStore } from "Stores/Calls";
import { cryptoKey } from "Static/constant";
import globalCallState from "Stores/GlobalCallState";
import { MXP_EVENT, PAGE_TYPE } from "Static/MixPanelEvents";

var CryptoJS = require("crypto-js");
let device;

const DialerSliderCard = observer(props => {
  const {
    data,
    slideAnimation = false,
    isBackArrow,
    backArrowCbk,
    dialerLogAfterCallEnd = true,
    performTaskCbk = () => {},
    isFromContactSection = false,
    pageType = "",
    isContactCard = false,
    selectedNumber = ""
  } = props || {};

  const {
    contactId: cId = "",
    phone,
    mobilePhone,
    otherPhone,
    firstName = "",
    lastName = "",
    name = "",
    id: contactId = ""
  } = data || {};

  const newPhoneArr =
    [...(phone || []), ...(mobilePhone || []), ...(otherPhone || [])]
      ?.flat(Infinity)
      ?.filter(element => {
        return element && !["[]", "[ ]"].includes(element);
      }) || [];

  const getNumberList = useCallback(() => {
    return selectedNumber?.length > 0 ? selectedNumber : newPhoneArr?.[0] || "";
  }, [mobilePhone, phone, otherPhone, selectedNumber]);

  const [loader, setLoader] = useState(true);
  const [tokenObj, setTokenObj] = useState(DialerServiceData.dialerTokenObj);
  const [dialerOption, setDialerOption] = useState({
    ...DialerServiceData?.dialerOption
  });
  const [callLogs, setCallLog] = useState(false);
  const [phoneNo, setPhoneNo] = useState(getNumberList());
  const [dialerCredits, setDialerCredits] = useState(
    userDetail.userFeatureFlag?.dialerCredits || 0
  );
  const [activeConnection, setActiveConnection] = useState(null);
  const [showUpgradeCredits, setUpgradeCredits] = useState(false);
  const [defaultNo, setDefaultNo] = useState(DialerServiceData.dialerDefaultNo);
  const [selectedChannel, setSelectedChannel] = useState("default");
  const [phoneNoEdited, setPhoneNoEdited] = useState(false);
  const [randomId, setRandomId] = useState("");
  const [closeBtnEnabled, setCloseBtnEnabled] = useState(true);
  const [isRecordingActivated, setRecordingActivated] = useState(false);
  const [toggleDropdown, setToggleDropDown] = useState(true);
  const [userEndedCall, setUserEndedCall] = useState(false);
  const [ringingAudio, setRingingAudio] = useState(null);
  const [callAttempted, setCallAttempted] = useState(false); // Track if a call was attempted
  const isEndingCallRef = useRef(false); // Ref to prevent duplicate endCall executions (synchronous)

  // Enforce channel selection based on feature flag
  useEffect(() => {
    const isChannelEnabled = userDetail.userFeatureFlag?.callingChannelEnabled;
    // Explicitly check for false, as undefined might mean feature not loaded or not relevant
    if (isChannelEnabled === false) {
      setSelectedChannel("default");
    }
  }, [userDetail.userFeatureFlag?.callingChannelEnabled]);

  const resetAndReloadCallStatsPage = () => {
    dialerLogsPopupState.setShowEditCallLogs(false);
    pageType === "calls" &&
      showCallLogsSliderCard() &&
      callsStore.setIsLogUpdated(true);
  };

  const closeDialerCard = () => {
    if (!DialerServiceData.dialerOption.call) {
      setCallLog(false);
      DialerServiceData.setDialerCallLogs(false);
      DialerServiceData.setDialerTokenObj(null);
      setDialerOption({ ...defaultDialerOption });
      setPhoneNoEdited(false);
      DialerServiceData.setDialerOption({ ...defaultDialerOption });
      DialerServiceData.setDialerCallNotes("");
      DialerServiceData.setDialerCallStatus("");
      DialerServiceData.setDialerIvrKeypad(false);
      setCallAttempted(false); // Reset callAttempted when closing dialer
      isEndingCallRef.current = false; // Reset endCall guard flag
      resetAndReloadCallStatsPage();
      globalCallState.resetPopupValues(true);
    } else {
      confirmationPopupState.setPopupValues({
        title: "Close Dialer?",
        content:
          "Are you sure you want to close?<br>Your call will get disconnected.",
        actionBtnText: "Yes",
        callback: () => {
          resetAndReloadCallStatsPage();
        }
      });
      confirmationPopupState.setShowPopup(true);
    }
  };

  const hideUpgrade = () => {
    setUpgradeCredits(false);
  };

  const phoneNoErrorPrompt = () => {
    confirmationPopupState.setPopupValues({
      content:
        "Please enter a valid phone number. Make sure to prefix the number with plus symbol (+) and country code.<br/><br/><span class='phoneExample'>Examples: +44 20xxx xxxx, +91 9xxxx xxxxx, +1 415 5xxxxxx</span>",
      actionBtnText: "Ok",
      needCancelBtn: false,
      callback: () => {}
    });
    confirmationPopupState.setShowPopup(true);
  };

  const getDecryptCapabilityToken = token => {
    if (token) {
      const keyForCryptoJS = CryptoJS.enc.Base64.parse(cryptoKey);
      const decodeBase64 = CryptoJS.enc.Base64.parse(token);
      const decryptedData = CryptoJS.AES.decrypt(
        {
          ciphertext: decodeBase64
        },
        keyForCryptoJS,
        {
          mode: CryptoJS.mode.ECB
        }
      );
      return decryptedData.toString(CryptoJS.enc.Utf8);
    } else {
      return null;
    }
  };

  // Dialer Service Mutliple Action Event Button
  const call = async () => {
    const usFreeCallingMinutesUsed =
      userDetail?.userFeatureFlag?.usFreeCallingMinutesEligible -
      userDetail?.userFeatureFlag?.usFreeCallingMinutesUsed;
    DialerServiceData.setDeviceStatus("");
    if (dialerCredits > 0.25 || usFreeCallingMinutesUsed > 1) {
      const { capabilityToken = "", statusCode = "" } = tokenObj || {};
      // Support both numeric (legacy) and string (new backend) status codes
      const isSuccess = statusCode === "SUCCESS" || statusCode === "200" || +statusCode === 200;
      if (capabilityToken && isSuccess) {
        setCloseBtnEnabled(isFromContactSection);
        if (phoneNo?.length > 6 && phoneNo?.length < 20) {
          if (phoneNo?.[0] === "+") {
            const newRandomNo = getAndSaveRandomId();
            // Store randomNo in dialerLogsPopupState so it's available when logging the call
            dialerLogsPopupState.setDialerLogSettings({
              ...dialerLogsPopupState.dialerLogSettings,
              randomNo: newRandomNo,
              phoneNumber: phoneNo
            });
            
            const params = {
              to_number: phoneNo,
              caller_id: String(defaultNo),
              record: false,
              task_id: globalCallState?.popupValues?.taskId || "",
              memberId: userDetail?.userInfo?.memberId,
              contactId: cId || contactId,
              randomNo: newRandomNo
            };
            // Add useTelnyx parameter when Channel 1 is selected
            if (selectedChannel === "channel1") {
              params.useTelnyx = true;
            }
            if (device) {
              // Prevent multiple simultaneous calls
              const currentCallStatus = DialerServiceData.dialerCallStatus?.toLowerCase();
              if (currentCallStatus === "calling" || currentCallStatus === "connected") {
                toasterState.setToastMsg(
                  "Another call is already in progress. Please end the current call first.",
                  "fail"
                );
                return;
              }

              if (["globalheader"].includes(pageType?.toLowerCase())) {
                Utils.mixpanelTrack(MXP_EVENT.GLOBAL_HEADER_DIALER_USED, {
                  pageType: PAGE_TYPE.header,
                  type: "Calling"
                });
              } else {
                Utils.mixpanelTrack(MXP_EVENT.DIALER_USED, {
                  type: "Calling"
                });
              }

              let call;
              let callTimeout;
              let ringingAudioRef = null; // Local reference for this call attempt
              let currentBitrate = 32000; // Start with high quality
              let qualityMetrics = {
                rtt: 0,
                jitter: 0,
                packetLoss: 0,
                quality: 'good'
              };
              let statsInterval = null;
              
              // Ensure device is registered before making calls
              const ensureDeviceReady = async (maxRetries = 3, retryDelay = 1000) => {
                for (let attempt = 0; attempt < maxRetries; attempt++) {
                  if (!device) {
                    throw new Error("Device not initialized");
                  }

                  const state = device.state;

                  // If device is registered, we're ready
                  if (state === "registered") {
                    return true;
                  }

                  // If device is registering, wait for it
                  if (state === "registering") {
                    await new Promise((resolve) => {
                      const timeout = setTimeout(() => {
                        device.off("registered", onRegistered);
                        resolve(false);
                      }, 10000); // 10 second timeout for registration

                      const onRegistered = () => {
                        clearTimeout(timeout);
                        device.off("registered", onRegistered);
                        resolve(true);
                      };

                      device.once("registered", onRegistered);
                    });
                    
                    if (device.state === "registered") {
                      return true;
                    }
                  }

                  // If device is not registered or failed, try to register
                  if (state === "unregistered" || state === "destroyed") {
                    try {
                      await device.register();
                      // Reduced wait time for faster response
                      await new Promise(resolve => setTimeout(resolve, 500));
                      
                      if (device.state === "registered") {
                        return true;
                      }
                    } catch (e) {
                      console.error(`Device registration attempt ${attempt + 1} failed:`, e);
                    }
                  }

                  // Wait before retrying
                  if (attempt < maxRetries - 1) {
                    await new Promise(resolve => setTimeout(resolve, retryDelay * (attempt + 1)));
                  }
                }

                throw new Error(`Device not ready after ${maxRetries} attempts. Current state: ${device?.state}`);
              };
              
              try {
                // Ensure device is ready before connecting
                try {
                  await ensureDeviceReady();
                } catch (deviceError) {
                  console.error("Device not ready:", deviceError);
                  toasterState.setToastMsg(
                    "Device connection timeout. Please try again in a moment.",
                    "fail"
                  );
                  return;
                }
                
                // Attempt connection with retry logic for transient failures
                let connectionAttempts = 0;
                const maxConnectionAttempts = 2;
                
                while (connectionAttempts < maxConnectionAttempts) {
                  try {
                    call = await device.connect({ params: params });
                    break; // Success, exit retry loop
                  } catch (connectError) {
                    connectionAttempts++;
                    const errorCode = connectError?.code || connectError?.message?.match(/\((\d+)\)/)?.[1];
                    
                    // Retry on connection timeout errors
                    if ((errorCode === "31000" || errorCode === 31000) && connectionAttempts < maxConnectionAttempts) {
                      console.warn(`Connection attempt ${connectionAttempts} failed, retrying...`);
                      // Wait before retrying with exponential backoff
                      await new Promise(resolve => setTimeout(resolve, 1000 * connectionAttempts));
                      // Ensure device is still ready
                      try {
                        await ensureDeviceReady();
                      } catch (e) {
                        throw new Error("Device became unavailable during retry");
                      }
                      continue;
                    }
                    
                    // For other errors or max attempts reached, throw
                    throw connectError;
                  }
                }
                
                // Start playing ringing sound when call is initiated
                // This provides audio feedback that the call is in progress
                const playRingingSound = () => {
                  try {
                    // Create a simple beep tone for ringing feedback
                    // Using Web Audio API to generate a ringing tone
                    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
                    const oscillator = audioContext.createOscillator();
                    const gainNode = audioContext.createGain();
                    
                    oscillator.connect(gainNode);
                    gainNode.connect(audioContext.destination);
                    
                    // Create a ringing tone pattern (beep-beep pattern)
                    // Use a more natural phone ring frequency (around 400-450 Hz)
                    oscillator.frequency.value = 425; // More natural ring tone frequency
                    oscillator.type = 'sine';
                    
                    // Create a pattern: beep on, beep off (ringing pattern)
                    // Slower, more natural timing like a real phone ring
                    const beepDuration = 0.7; // 700ms beep (longer, more natural)
                    const pauseDuration = 0.7; // 700ms pause between beeps (longer interval)
                    const cycleDuration = beepDuration + pauseDuration; // 1.5 seconds total
                    const initialDelay = 700; // 800ms delay before first beep starts
                    
                    let beepInterval = null;
                    
                    const stopRinging = () => {
                      if (beepInterval) {
                        clearInterval(beepInterval);
                        beepInterval = null;
                      }
                      try {
                        oscillator.stop();
                        audioContext.close();
                      } catch (e) {
                        // Ignore errors when stopping
                      }
                      ringingAudioRef = null;
                      setRingingAudio(null);
                    };
                    
                    // Start the oscillator
                    oscillator.start();
                    
                    // Create beeping pattern with more natural fade in/out
                    const playBeepCycle = () => {
                      const now = audioContext.currentTime;
                      gainNode.gain.cancelScheduledValues(now);
                      // Fade in slightly for smoother sound
                      gainNode.gain.setValueAtTime(0, now);
                      gainNode.gain.linearRampToValueAtTime(0.12, now + 0.05); // Gentle fade in
                      gainNode.gain.setValueAtTime(0.12, now + beepDuration - 0.1); // Hold
                      gainNode.gain.linearRampToValueAtTime(0, now + beepDuration); // Fade out
                    };
                    
                    // Play first beep after initial delay
                    setTimeout(() => {
                      // Check if we should still play (call might have connected/disconnected)
                      const callStatus = DialerServiceData.dialerCallStatus?.toLowerCase();
                      if (callStatus === "calling") {
                        playBeepCycle();
                      }
                    }, initialDelay);
                    
                    // Continue beeping pattern
                    beepInterval = setInterval(() => {
                      // Check multiple conditions to stop beeping
                      const callStatus = DialerServiceData.dialerCallStatus?.toLowerCase();
                      
                      // Stop beeping if status is no longer "calling" (could be ringing, connected, disconnected, ended, etc.)
                      if (callStatus !== "calling" && callStatus !== "") {
                        stopRinging();
                        return;
                      }
                      
                      // Also check if user ended call manually
                      if (userEndedCall) {
                        stopRinging();
                        return;
                      }
                      
                      // Also check connection status directly from call object
                      try {
                        if (call) {
                          // Check if we can get connection status
                          let connStatus = null;
                          
                          // Try to get connection from call
                          let conn = null;
                          if (call.connection) {
                            conn = call.connection;
                          } else if (call.getConnection) {
                            conn = call.getConnection();
                          }
                          
                          if (conn && conn.status) {
                            connStatus = conn.status().toLowerCase();
                          } else if (call.status) {
                            connStatus = call.status().toLowerCase();
                          }
                          
                          // Stop beep if connection is ringing, open, or closed
                          if (connStatus === "ringing" || connStatus === "open" || connStatus === "closed") {
                            stopRinging();
                            return;
                          }
                        }
                      } catch (e) {
                        // Ignore errors
                      }
                      
                      // Continue beeping if still in calling state
                      playBeepCycle();
                    }, cycleDuration * 1000);
                    
                    // Monitor connection status to detect when phone actually starts ringing
                    // This will stop the beep as soon as the remote phone starts ringing
                    let checkConnectionStatus = null;
                    
                    // Wrap stopRinging to also clear the status check interval
                    const originalStopRinging = stopRinging;
                    stopRinging = () => {
                      if (checkConnectionStatus) {
                        clearInterval(checkConnectionStatus);
                        checkConnectionStatus = null;
                      }
                      originalStopRinging();
                    };
                    
                    // Start monitoring connection status after a short delay
                    setTimeout(() => {
                      checkConnectionStatus = setInterval(() => {
                        try {
                          // First check if call status has changed (user ended call, disconnected, etc.)
                          const callStatus = DialerServiceData.dialerCallStatus?.toLowerCase();
                          if (callStatus && callStatus !== "calling" && callStatus !== "") {
                            // Status changed - stop ringing immediately
                            stopRinging();
                            return;
                          }

                          // Check call connection status
                          if (call) {
                            // Try multiple ways to get connection status
                            let shouldStop = false;
                            
                            // Method 1: Try to get connection from call object
                            const connection = call.getConnection ? call.getConnection() :
                                             (call.connection ? call.connection : null);
                            
                            if (connection && connection.status) {
                              const connStatus = connection.status().toLowerCase();
                              // Stop beep when phone starts ringing or call connects
                              if (connStatus === "ringing" || connStatus === "open" || connStatus === "closed") {
                                shouldStop = true;
                              }
                            }
                            
                            // Method 2: Check call status directly
                            if (!shouldStop && call.status) {
                              const callStatus = call.status().toLowerCase();
                              if (callStatus === "ringing" || callStatus === "open" || callStatus === "closed") {
                                shouldStop = true;
                              }
                            }
                            
                            // Method 3: Check if call has been accepted (connection exists means it's been accepted)
                            if (!shouldStop && connection) {
                              // If connection exists, it means accept event has fired or will fire soon
                              // Stop beep to be safe
                              shouldStop = true;
                            }
                            
                            if (shouldStop) {
                              stopRinging();
                            }
                          }
                        } catch (e) {
                          // Ignore errors, will be cleaned up
                        }
                      }, 100); // Check every 100ms for fast detection
                    }, 500); // Start monitoring after 500ms
                    
                    // Store reference to stop if needed
                    ringingAudioRef = { stop: stopRinging };
                    setRingingAudio(ringingAudioRef);
                    
                  } catch (e) {
                    console.warn("Could not play ringing sound:", e);
                    // Fallback: Just log if audio API is not available
                  }
                };
                
                // Start ringing sound after a small delay
                setTimeout(playRingingSound, 100);
                
              } catch (error) {
                console.error("Failed to connect call:", error);
                // Preserve status instead of clearing it - set to "disconnected" so endCall() can detect it
                DialerServiceData.setDialerCallStatus("disconnected");
                // Stop ringing if call fails
                if (ringingAudioRef?.stop) {
                  ringingAudioRef.stop();
                  ringingAudioRef = null;
                  setRingingAudio(null);
                }
                toasterState.setToastMsg(
                  "Failed to initiate call. Please try again.",
                  "fail"
                );
                // Call endCall() to properly clean up and show call log
                setTimeout(() => {
                  endCall();
                }, 100);
                return;
              }

              // Monitor connection status changes to detect when call starts ringing
              // This allows us to stop the beep as soon as the phone starts ringing
              let connectionStatusMonitor = null;
              
              // Listen for when connection is established so we can monitor its status
              const setupConnectionMonitoring = (conn) => {
                if (!conn || connectionStatusMonitor) return;
                
                // Monitor connection status changes
                connectionStatusMonitor = setInterval(() => {
                  try {
                    if (conn && conn.status) {
                      const connStatus = conn.status().toLowerCase();
                      
                      // Stop beep when phone starts ringing (before it's accepted)
                      if (connStatus === "ringing") {
                        if (ringingAudioRef?.stop) {
                          ringingAudioRef.stop();
                        }
                        if (connectionStatusMonitor) {
                          clearInterval(connectionStatusMonitor);
                          connectionStatusMonitor = null;
                        }
                      } else if (connStatus === "open" || connStatus === "closed") {
                        // Also stop if connected or closed
                        if (ringingAudioRef?.stop) {
                          ringingAudioRef.stop();
                        }
                        if (connectionStatusMonitor) {
                          clearInterval(connectionStatusMonitor);
                          connectionStatusMonitor = null;
                        }
                      }
                    }
                  } catch (e) {
                    // Ignore errors, will be cleaned up
                  }
                }, 100); // Check every 100ms for fast detection
              };
              
              // Try to get connection from call immediately if available
              // For outgoing calls, connection might not be available until accept event
              // But we'll also listen for connection state changes
              if (call) {
                // Listen for any connection-related events
                const checkCallForConnection = setInterval(() => {
                  try {
                    // Try to access connection from call object
                    // Twilio SDK may expose connection differently
                    let conn = null;
                    
                    // Try different ways to access the connection
                    if (call.connection) {
                      conn = call.connection;
                    } else if (call.getConnection) {
                      conn = call.getConnection();
                    } else if (call._connection) {
                      conn = call._connection;
                    }
                    
                    if (conn) {
                      clearInterval(checkCallForConnection);
                      setupConnectionMonitoring(conn);
                    }
                  } catch (e) {
                    // Connection not ready yet, keep checking
                  }
                }, 200);
                
                // Clean up after 10 seconds if no connection found
                setTimeout(() => {
                  clearInterval(checkCallForConnection);
                }, 10000);
              }

              call.on("disconnect", conn => {
                // Clear timeout since call disconnected
                if (callTimeout) {
                  clearTimeout(callTimeout);
                  callTimeout = null;
                }
                
                // Stop ringing sound when call disconnects
                if (ringingAudioRef?.stop) {
                  ringingAudioRef.stop();
                }
                
                // Clean up quality monitoring
                if (statsInterval) {
                  clearInterval(statsInterval);
                  statsInterval = null;
                }
                
                DialerServiceData.setDeviceStatus(conn?.status() || "");
                // Only call endCall if userEndedCall is not set (auto-disconnect, not user-initiated)
                // If user already clicked end call, don't call endCall again to avoid resetting the log popup
                if (!userEndedCall) {
                  const currentStatus = DialerServiceData.dialerCallStatus?.toLowerCase();
                  if (currentStatus === "connected") {
                    DialerServiceData.setDialerCallStatus("ended");
                    setTimeout(() => {
                      endCall();
                    }, 1000);
                  } else if (currentStatus === "ended") {
                    endCall();
                  } else if (currentStatus === "calling") {
                    // Call disconnected while still in calling state (never connected)
                    DialerServiceData.setDialerCallStatus("disconnected");
                    endCall(); // Call immediately, no timeout needed
                  } else {
                    DialerServiceData.setDialerCallStatus("disconnected");
                    setTimeout(() => {
                      endCall();
                    }, 1000);
                  }
                }
              });

              // Connection quality monitoring
              call.on("warning", (name, data) => {
                console.warn("Call quality warning:", name, data);
                
                if (name === "high-rtt") {
                  qualityMetrics.quality = 'fair';
                  qualityMetrics.rtt = data.rtt || 0;
                  
                  // Reduce bitrate if RTT is high
                  const conn = activeConnection || call;
                  if (data.rtt > 300 && conn) {
                    currentBitrate = Math.max(16000, currentBitrate - 4000);
                    try {
                      // Try different methods depending on SDK version
                      if (conn.setMaxBitrate) {
                        conn.setMaxBitrate(currentBitrate);
                      } else if (conn.updateAudioSettings) {
                        conn.updateAudioSettings({ maxAverageBitrate: currentBitrate });
                      }
                      console.log(`Reduced bitrate to ${currentBitrate}bps due to high RTT`);
                    } catch (e) {
                      console.warn("Could not set bitrate:", e);
                    }
                  }
                }
                
                if (name === "high-jitter") {
                  qualityMetrics.jitter = data.jitter || 0;
                  qualityMetrics.quality = 'fair';
                }
                
                if (name === "high-packet-loss") {
                  qualityMetrics.packetLoss = data.packetLoss || 0;
                  qualityMetrics.quality = 'poor';
                  
                  // Significantly reduce bitrate on packet loss
                  const conn = activeConnection || call;
                  if (conn && currentBitrate > 16000) {
                    currentBitrate = Math.max(16000, currentBitrate - 8000);
                    try {
                      // Try different methods depending on SDK version
                      if (conn.setMaxBitrate) {
                        conn.setMaxBitrate(currentBitrate);
                      } else if (conn.updateAudioSettings) {
                        conn.updateAudioSettings({ maxAverageBitrate: currentBitrate });
                      }
                      console.log(`Reduced bitrate to ${currentBitrate}bps due to packet loss`);
                    } catch (e) {
                      console.warn("Could not set bitrate:", e);
                    }
                  }
                  
                  // Notify user
                  toasterState.setToastMsg(
                    "Poor network connection detected. Audio quality may be reduced.",
                    "warning"
                  );
                }
              });

              call.on("warning-cleared", (name) => {
                console.log("Quality warning cleared:", name);
                
                // Gradually increase bitrate when quality improves
                if (qualityMetrics.quality === 'good' && currentBitrate < 32000) {
                  setTimeout(() => {
                    const conn = activeConnection || call;
                    if (conn && DialerServiceData.dialerCallStatus === "connected") {
                      currentBitrate = Math.min(32000, currentBitrate + 4000);
                      try {
                        // Try different methods depending on SDK version
                        if (conn.setMaxBitrate) {
                          conn.setMaxBitrate(currentBitrate);
                        } else if (conn.updateAudioSettings) {
                          conn.updateAudioSettings({ maxAverageBitrate: currentBitrate });
                        }
                        console.log(`Increased bitrate to ${currentBitrate}bps`);
                      } catch (e) {
                        console.warn("Could not set bitrate:", e);
                      }
                    }
                  }, 5000);  // Wait 5 seconds before increasing
                }
              });

              // Listen for accept event - this fires when connection is established
              // This is typically when the remote phone starts ringing
              call.on("accept", conn => {
                // Clear timeout since call was accepted
                if (callTimeout) {
                  clearTimeout(callTimeout);
                  callTimeout = null;
                }
                
                // Stop ringing sound IMMEDIATELY when accept event fires
                // This happens when connection is established, which is when phone starts ringing
                if (ringingAudioRef?.stop) {
                  ringingAudioRef.stop();
                  ringingAudioRef = null;
                  setRingingAudio(null);
                }
                
                // Clean up connection status monitor
                if (connectionStatusMonitor) {
                  clearInterval(connectionStatusMonitor);
                  connectionStatusMonitor = null;
                }
                
                DialerServiceData.setDeviceStatus(conn?.status() || "");
                setActiveConnection(conn);
                
                // Setup monitoring for this connection (in case it's not open yet)
                setupConnectionMonitoring(conn);
                
                // Start connection quality monitoring
                if (conn && conn.getStats) {
                  statsInterval = setInterval(async () => {
                    try {
                      const stats = await conn.getStats();
                      
                      // Parse WebRTC stats for RTT, jitter, packet loss
                      if (stats && stats.length > 0) {
                        stats.forEach(report => {
                          if (report.type === 'remote-inbound-rtp' || report.type === 'inbound-rtp') {
                            qualityMetrics.rtt = report.roundTripTime || 0;
                            qualityMetrics.jitter = report.jitter || 0;
                            
                            if (report.packetsLost !== undefined && report.packetsReceived !== undefined) {
                              const totalPackets = report.packetsLost + report.packetsReceived;
                              qualityMetrics.packetLoss = totalPackets > 0 
                                ? (report.packetsLost / totalPackets) * 100 
                                : 0;
                            }
                          }
                        });
                        
                        // Update quality status
                        if (qualityMetrics.rtt > 300 || qualityMetrics.jitter > 50 || qualityMetrics.packetLoss > 5) {
                          qualityMetrics.quality = 'poor';
                        } else if (qualityMetrics.rtt > 150 || qualityMetrics.jitter > 30 || qualityMetrics.packetLoss > 2) {
                          qualityMetrics.quality = 'fair';
                        } else {
                          qualityMetrics.quality = 'good';
                        }
                      }
                    } catch (e) {
                      console.error("Error getting call stats:", e);
                    }
                  }, 5000);  // Check every 5 seconds
                }
                
                // Set status to connected immediately - no delay to avoid silence
                // Check connection status to detect if call is actually open
                const connectionStatus = conn?.status()?.toLowerCase() || "";
                
                // If connection is open, set connected immediately
                if (connectionStatus === "open") {
                  DialerServiceData.setDialerCallStatus("connected");
                  
                  // Get callSid and update settings immediately
                  let callSid =
                    conn?.mediaStream?.CallSid || conn?.parameters?.CallSid;
                  if (callSid) {
                    dialerLogsPopupState.setDialerLogSettings({
                      ...dialerLogsPopupState.dialerLogSettings,
                      ...{
                        callSid,
                        contactName: Utils.getName(firstName, lastName, name)
                      }
                    });
                  }
                  
                  // Start recording ONLY after call is fully connected
                  // Wait a bit longer to ensure connection is stable and audio is flowing
                  if (userDetail.userFeatureFlag.recordingEnabled) {
                setTimeout(() => {
                      // Double-check that call is still connected before starting recording
                      const currentStatus = DialerServiceData.dialerCallStatus?.toLowerCase();
                      const currentDeviceStatus = DialerServiceData?.deviceStatus?.toLowerCase();
                      
                  if (
                        currentStatus === "connected" &&
                        currentDeviceStatus !== "closed" &&
                        conn?.status()?.toLowerCase() === "open"
                  ) {
                      handleCallRecording("start", conn);
                      }
                    }, 1000); // Increased delay to ensure connection is stable
                  }
                } else {
                  // Connection not fully open yet, wait a bit and check again
                  setTimeout(() => {
                    if (
                      DialerServiceData?.deviceStatus?.toLowerCase() !== "closed" &&
                      conn?.status()?.toLowerCase() === "open"
                    ) {
                    DialerServiceData.setDialerCallStatus("connected");
                    let callSid =
                      conn?.mediaStream?.CallSid || conn?.parameters?.CallSid;
                      if (callSid) {
                    dialerLogsPopupState.setDialerLogSettings({
                      ...dialerLogsPopupState.dialerLogSettings,
                      ...{
                        callSid,
                            contactName: Utils.getName(firstName, lastName, name)
                          }
                        });
                      }
                      
                      // Start recording ONLY after confirming connection status
                      if (userDetail.userFeatureFlag.recordingEnabled) {
                        const currentStatus = DialerServiceData.dialerCallStatus?.toLowerCase();
                        if (currentStatus === "connected") {
                          handleCallRecording("start", conn);
                        }
                      }
                    }
                  }, 1000);
                }
              });

              call.on("reject", () => {
                // Call was rejected (busy, no-answer, voicemail, etc.)
                if (callTimeout) {
                  clearTimeout(callTimeout);
                  callTimeout = null;
                }
                
                // Stop ringing sound when call is rejected
                if (ringingAudioRef?.stop) {
                  ringingAudioRef.stop();
                }
                
                if (!userEndedCall) {
                  const currentStatus = DialerServiceData.dialerCallStatus?.toLowerCase();
                  if (currentStatus === "calling" || currentStatus === "connected") {
                    DialerServiceData.setDialerCallStatus("disconnected");
                    // Small delay to ensure log popup shows for rejected calls
                    setTimeout(() => {
                      endCall();
                    }, 300);
                  }
                }
              });

              call.on("cancel", () => {
                // Call was cancelled
                if (callTimeout) {
                  clearTimeout(callTimeout);
                  callTimeout = null;
                }
                
                // Stop ringing sound when call is cancelled
                if (ringingAudioRef?.stop) {
                  ringingAudioRef.stop();
                }
                
                if (!userEndedCall) {
                  const currentStatus = DialerServiceData.dialerCallStatus?.toLowerCase();
                  if (currentStatus === "calling" || currentStatus === "connected") {
                    DialerServiceData.setDialerCallStatus("disconnected");
                    // Small delay to ensure log popup shows for cancelled calls
                    setTimeout(() => {
                      endCall();
                    }, 300);
                  }
                }
              });

              call.on("error", (error) => {
                // Handle call-specific errors
                console.error("Call error:", error);
                if (callTimeout) {
                  clearTimeout(callTimeout);
                  callTimeout = null;
                }
                
                // Stop ringing sound when call errors
                if (ringingAudioRef?.stop) {
                  ringingAudioRef.stop();
                }
                
                if (!userEndedCall) {
                  DialerServiceData.setDialerCallStatus("disconnected");
                  
                  // Extract error code from various possible locations in Twilio error object
                  let errorCode = null;
                  const errorMessageStr = error?.message || error?.toString() || "";
                  
                  // Try to extract from error.code property
                  if (error?.code) {
                    errorCode = error.code;
                  } else if (error?.twilioErrorCode) {
                    errorCode = error.twilioErrorCode;
                  } else {
                    // Try to extract from error message string - looks for patterns like "(31005)" or "31005"
                    const codeMatch = errorMessageStr.match(/\((\d+)\)|:\s*(\d+)/);
                    if (codeMatch) {
                      errorCode = codeMatch[1] || codeMatch[2];
                    } else {
                      // Try to find any 5-digit number (Twilio error codes are typically 5 digits)
                      const allCodes = errorMessageStr.match(/\b\d{5}\b/g);
                      if (allCodes && allCodes.length > 0) {
                        errorCode = allCodes[0];
                      }
                    }
                  }
                  
                  let errorMessage = "Call failed. Please try again.";
                  
                  // Handle specific Twilio error codes
                  if (errorCode) {
                    const code = parseInt(errorCode);
                    switch (code) {
                      case 31005:
                        // ConnectionError: Error sent from gateway in HANGUP
                        // This can be caused by:
                        // 1. Invalid/unreachable number
                        // 2. Carrier blocking
                        // 3. Regional restrictions
                        // 4. Network congestion (transient)
                        // 5. Twilio service issues (transient)
                        
                        // Log detailed error for debugging
                        console.error("Error 31005 - Network rejection details:", {
                          error: error,
                          phoneNumber: params?.to_number,
                          callerId: params?.caller_id,
                          timestamp: new Date().toISOString(),
                          errorMessage: errorMessageStr
                        });
                        
                        // Check if error message provides more context
                        const lowerErrorMsg = errorMessageStr.toLowerCase();
                        let specificContext = "";
                        
                        if (lowerErrorMsg.includes("invalid") || lowerErrorMsg.includes("unreachable")) {
                          specificContext = "The phone number may be invalid or unreachable.";
                        } else if (lowerErrorMsg.includes("blocked") || lowerErrorMsg.includes("restricted")) {
                          specificContext = "The number may be blocked or restricted.";
                        } else if (lowerErrorMsg.includes("busy") || lowerErrorMsg.includes("no-answer")) {
                          specificContext = "The number is busy or not answering.";
                        } else if (lowerErrorMsg.includes("rate limit") || lowerErrorMsg.includes("throttle")) {
                          specificContext = "Too many calls in a short time. Please wait a moment.";
                        }
                        
                        errorMessage = specificContext 
                          ? `Call was rejected by the network. ${specificContext} Please try again later.`
                          : "Call was rejected by the network. The number may be unreachable, blocked, or the carrier rejected the call. Please try again later.";
                        break;
                      case 31000:
                        errorMessage = "Connection timeout. Please check your internet connection and try again.";
                        break;
                      case 31001:
                        errorMessage = "Connection error. Please try again.";
                        break;
                      case 31002:
                        errorMessage = "Connection dropped. Please try again.";
                        break;
                      case 31003:
                        errorMessage = "Call canceled by the network. Please try again.";
                        break;
                      case 31004:
                        errorMessage = "Connection failed. Please check your internet connection and try again.";
                        break;
                      case 31008:
                        errorMessage = "Call connection error. Please try again.";
                        break;
                      default:
                        // Check error message for additional context
                        if (errorMessageStr.includes("HANGUP") || errorMessageStr.includes("hangup")) {
                          errorMessage = "Call was disconnected by the network. Please try again or contact support if the issue persists.";
                        } else if (errorMessageStr.includes("ConnectionError") || errorMessageStr.includes("connection error")) {
                          errorMessage = "Connection error occurred. Please try again.";
                        } else if (errorMessageStr.includes("gateway")) {
                          errorMessage = "Call was rejected by the network gateway. Please try again later.";
                        }
                        break;
                    }
                  } else {
                    // Fallback to check error message content if no code found
                    const errorMsg = errorMessageStr.toLowerCase();
                    if (errorMsg.includes("hangup") || errorMsg.includes("gateway")) {
                      errorMessage = "Call was rejected by the network. Please try again later or contact support if the issue persists.";
                    } else if (errorMsg.includes("timeout")) {
                      errorMessage = "Call timed out. Please try again.";
                    } else if (errorMsg.includes("connection")) {
                      errorMessage = "Connection error. Please check your internet connection and try again.";
                    }
                  }
                  
                  toasterState.setToastMsg(errorMessage, "fail");
                  
                  // Ensure callSid is preserved if it exists for logging failed calls
                  // Even failed calls should show the log popup if dialerLogAfterCallEnd is enabled
                  // Small delay to ensure status is set before calling endCall
                  setTimeout(() => {
                    endCall();
                  }, 500);
                }
              });

              // Set up call timeout - if call is stuck in "calling" state for too long
              callTimeout = setTimeout(() => {
                const status = DialerServiceData.dialerCallStatus?.toLowerCase();
                if (status === "calling" && !userEndedCall) {
                  console.warn("Call timeout - call stuck in calling state");
                  DialerServiceData.setDialerCallStatus("disconnected");
                  toasterState.setToastMsg(
                    "Call timed out. Please try again.",
                    "fail"
                  );
                  if (call) {
                    call.disconnect();
                  }
                  endCall();
                }
              }, 60000); // 60 second timeout

              // Mark that a call was attempted
              setCallAttempted(true);
              DialerServiceData.setDialerCallStatus("Calling");
              DialerServiceData.setDialerOption({
                ...dialerOption,
                ...{
                  call: true,
                  record: false,
                  keypad: false
                }
              });
            }
          } else {
            phoneNoErrorPrompt();
          }
        } else {
          phoneNoErrorPrompt();
        }
      } else if (statusCode === "UNAUTHORIZED" || statusCode === "401" || +statusCode === 401) {
        toasterState.setToastMsg("UNAUTHORIZED Access", "fail");
      } else if (statusCode === "PLAN_UPGRADE" || statusCode === "426" || +statusCode === 426) {
        toasterState.setToastMsg("Please upgrade to continue", "fail");
      } else if (statusCode === "CREDITS_UPDATE_REQUIRED" || statusCode === "427" || +statusCode === 427) {
        setUpgradeCredits(true);
      } else if (statusCode === "DEFAULT_NUMBER_NOT_CONFIGURED" || statusCode === "428" || +statusCode === 428) {
        toasterState.setToastMsg("Please configure a default phone number", "fail");
      } else if (statusCode === "INTERNAL_ERROR" || statusCode === "500" || +statusCode === 500) {
        toasterState.setToastMsg("An internal error occurred. Please try again later", "fail");
      } else {
        toasterState.setToastMsg(
          "Something went wrong. Please try again later",
          "fail"
        );
      }
    } else {
      setUpgradeCredits(true);
    }
  };

  const endCall = () => {
    // Prevent duplicate calls to endCall (using ref for synchronous check)
    if (isEndingCallRef.current) {
      return;
    }
    isEndingCallRef.current = true;
    
    // Stop ringing sound IMMEDIATELY when call ends
    // Try multiple ways to ensure it stops
    if (ringingAudio?.stop) {
      try {
        ringingAudio.stop();
      } catch (e) {
        console.warn("Error stopping ringing audio in endCall:", e);
      }
    }
    // Clear the state immediately
    setRingingAudio(null);
    
    if (device) {
      // Disconnect active connection first if it exists
      if (activeConnection) {
        try {
          // Ensure connection is properly disconnected
          if (activeConnection.status && activeConnection.status() !== "closed") {
            activeConnection.disconnect();
          }
        } catch (e) {
          console.warn("Error disconnecting connection:", e);
        }
      }
      
      // Disconnect all calls on the device
      try {
        device.disconnectAll();
      } catch (e) {
        console.warn("Error disconnecting all calls:", e);
      }
      
      DialerServiceData.setDialerTokenObj(null);
      DialerServiceData.setDialerOption({ ...defaultDialerOption });
      setDialerOption({ ...defaultDialerOption });
      const previousStatus = DialerServiceData.dialerCallStatus;
      DialerServiceData.setDialerCallStatus("");
      DialerServiceData.setDialerIvrKeypad(false);
      DialerServiceData.setDialerCallLogs(true);
      
      // Always show call log if:
      // 1. User ended the call manually, OR
      // 2. dialerLogAfterCallEnd is enabled, OR
      // 3. Call was connected (has callSid), OR
      // 4. Call failed but we attempted to call (previousStatus was "calling" or "disconnected"), OR
      // 5. A call was attempted (callAttempted flag is true) - ensures log shows even if status was cleared
      const shouldShowLog = 
        userEndedCall || 
        dialerLogAfterCallEnd || 
        dialerLogsPopupState.dialerLogSettings.callSid ||
        callAttempted || // Always show log if call was attempted
        (previousStatus?.toLowerCase() === "calling" || previousStatus?.toLowerCase() === "disconnected");
      
      if (shouldShowLog) {
        setCallLog(true);
      } else {
        setCallLog(dialerLogsPopupState.dialerLogSettings.callSid);
      }
      
      // Clear active connection after disconnecting
      setActiveConnection(null);
      
      // Don't close dialer card if we should show log popup or if a call was attempted
      // This ensures dialer stays open and log is shown even on errors
      if (!shouldShowLog && !userEndedCall && !callAttempted) {
        closeDialerCard();
      }
      
      // Reset callAttempted flag AFTER component has rendered with call log
      // Delay reset to avoid race condition where flag is reset before render
      setTimeout(() => {
        setCallAttempted(false);
        isEndingCallRef.current = false; // Allow endCall to be called again for next call
      }, 500);
      
      // callback to perform task operation
      if (globalCallState.popupValues.pageType === "tasks") {
        !dialerLogAfterCallEnd && performTaskCbk();
      }
    }
  };

  const handleMute = value => {
    if (device && activeConnection) {
      try {
        // Check if connection is still valid
        const connStatus = activeConnection.status ? activeConnection.status() : null;
        if (!connStatus || connStatus === "closed") {
          console.warn("Cannot mute/unmute: connection is closed");
          return;
        }
        
        // Update state first
        const updatedOption = { ...dialerOption, mute: value };
        DialerServiceData.setDialerOption(updatedOption);
        setDialerOption(updatedOption);
        
        // Call Twilio mute/unmute methods
        if (value) {
          // Mute the connection
          if (typeof activeConnection.mute === 'function') {
            activeConnection.mute();
          } else {
            console.warn("activeConnection.mute is not a function");
          }
        } else {
          // Unmute the connection
          if (typeof activeConnection.unmute === 'function') {
            activeConnection.unmute();
          } else {
            console.warn("activeConnection.unmute is not a function");
            // Try alternative method if unmute doesn't exist
            if (typeof activeConnection.mute === 'function') {
              // Some SDK versions might use mute(false) to unmute
              try {
                activeConnection.mute(false);
              } catch (e) {
                console.error("Error unmuting via mute(false):", e);
              }
            }
          }
        }
      } catch (e) {
        console.error("Error toggling mute:", e);
        // Revert state on error
        const revertedOption = { ...dialerOption, mute: !value };
        DialerServiceData.setDialerOption(revertedOption);
        setDialerOption(revertedOption);
      }
    } else {
      console.warn("Cannot mute/unmute: device or activeConnection not available", { device: !!device, activeConnection: !!activeConnection });
    }
  };

  const handleCallRecording = async (type = "", conn = {}) => {
    if (
      activeConnection?.mediaStream?.CallSid ||
      activeConnection?.parameters?.CallSid ||
      conn?.mediaStream?.CallSid ||
      conn?.parameters?.CallSid
    ) {
      let callSid =
        activeConnection?.mediaStream?.CallSid ||
        activeConnection?.parameters?.CallSid ||
        conn?.mediaStream?.CallSid ||
        conn?.parameters?.CallSid;
      let url =
        type === "start"
          ? URLS.startRecording
          : type === "pause"
          ? URLS.pasueRecording
          : URLS.resumeRecording;
      try {
        const config = {
          url: url.replace("<<callSid>>", callSid),
          method: "POST"
        };
        let res = await makeApi(config);
        if (res?.data?.status === "success") {
          type === "start" && setRecordingActivated(true);
          DialerServiceData.setDialerOption({
            ...dialerOption,
            ...{
              call: true,
              keypad: false,
              record: ["start", "resume"].includes(type)
            }
          });
        } else {
          toasterState.setToastMsg(
            "Something went wrong. Please try again later",
            "fail"
          );
        }
      } catch (e) {
        console.error(e, "Recording Error");
      }
    }
  };

  const getPhoneNo = (no = "") => {
    setPhoneNo(no?.trim() || "");
    setPhoneNoEdited(true);
    dialerLogsPopupState.setDialerLogSettings({
      ...dialerLogsPopupState.dialerLogSettings,
      ...{
        phoneNumber: no?.trim() || "",
        isContactHasNo: true
      }
    });
  };

  const dialerServiceMultiEvent = (name = "") => {
    switch (name) {
      case "call":
        call(false);
        break;
      case "endCall":
        setUserEndedCall(true);
        // Stop ringing audio IMMEDIATELY when user manually ends call
        if (ringingAudio?.stop) {
          try {
            ringingAudio.stop();
          } catch (e) {
            console.warn("Error stopping ringing audio:", e);
          }
        }
        // Also try to stop via state directly
        setRingingAudio(null);
                // Set status to ended/disconnected before calling endCall
        const currentStatus = DialerServiceData.dialerCallStatus?.toLowerCase();
        if (currentStatus === "connected") {
          DialerServiceData.setDialerCallStatus("ended");
        } else if (currentStatus === "calling") {
          DialerServiceData.setDialerCallStatus("disconnected");
        } else {
          DialerServiceData.setDialerCallStatus("disconnected");
        }
        // Call endCall immediately for manual disconnect
        endCall();
        break;
      case "mute":
        handleMute(true);
        break;
      case "unmute":
        handleMute(false);
        break;
      case "startRecording":
        DialerServiceData?.deviceStatus?.toLowerCase() === "open" &&
          handleCallRecording("start");
        break;
      case "pauseRecording":
        handleCallRecording("pause");
        break;
      case "resumeRecording":
        handleCallRecording("resume");
        break;
      default:
        break;
    }
  };

  // Twilio Setup
  const updateAllDevices = () => {
    updateDevices(device.audio.speakerDevices.get());
  };

  const updateDevices = selectedDevices => {
    device.audio.availableOutputDevices.forEach((dev, id) => {
      let isActive = selectedDevices.size === 0 && id === "default";
      selectedDevices.forEach(dev => {
        if (dev.deviceId === id) {
          isActive = true;
        }
      });
    });
  };

  // Dynamic edge selection based on user location (with caching)
  const selectOptimalEdge = async () => {
    const CACHE_KEY = 'dialer_edge_selection';
    const CACHE_DURATION = 60 * 180 * 1000; // 1 hour in milliseconds
    
    try {
      // Check cache first
      const cached = localStorage.getItem(CACHE_KEY);
      if (cached) {
        const { edges, timestamp } = JSON.parse(cached);
        const now = Date.now();
        
        // Return cached edges if still valid
        if (now - timestamp < CACHE_DURATION) {
          return edges;
        }
      }
      
      // Cache expired or doesn't exist, fetch new location
      // Use timeout to prevent blocking if API is slow
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 2000); // 2 second timeout
      
      try {
        const response = await fetch('https://ipapi.co/json/', {
          signal: controller.signal
        });
        clearTimeout(timeoutId);
        
        const location = await response.json();
        const region = location?.country_code?.toLowerCase() || 'us';
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        
        let edges = [];
        if (region === 'us' || region === 'ca' || timezone.includes('America')) {
          edges = ["ashburn", "dublin"];  // US/East Coast
        } else if (region === 'gb' || region === 'ie' || region === 'de' || region === 'fr' || timezone.includes('Europe')) {
          edges = ["dublin", "ashburn"];  // Europe
        } else if (region === 'au' || region === 'nz' || region === 'jp' || region === 'sg' || timezone.includes('Pacific')) {
          edges = ["sydney", "tokyo"];  // Asia-Pacific
        } else {
          edges = ["dublin", "ashburn"];  // Default
        }
        
        // Cache the result
        localStorage.setItem(CACHE_KEY, JSON.stringify({
          edges,
          timestamp: Date.now()
        }));
        
        return edges;
      } catch (fetchError) {
        clearTimeout(timeoutId);
        // If fetch fails, try to use cached value even if expired
        if (cached) {
          const { edges } = JSON.parse(cached);
          console.warn("Location API failed, using expired cache:", fetchError);
          return edges;
        }
        throw fetchError;
      }
    } catch (e) {
      console.warn("Could not determine location, using default edges:", e);
      return ["ashburn", "dublin"];  // Fallback
    }
  };

  const configureTwilioDevice = async (payload) => {
    const decryptCapabilityToken = getDecryptCapabilityToken(
      payload?.capabilityToken
    );
    if (decryptCapabilityToken) {
      // Select optimal edge based on user location
      const optimalEdges = await selectOptimalEdge();
      
      // Destroy existing device if present
      if (device) {
        try {
          device.destroy();
        } catch (e) {
          console.warn("Error destroying existing device:", e);
        }
      }
      
      device = new Device(decryptCapabilityToken, {
        codecPreferences: ["opus", "pcmu"],
        maxAverageBitrate: 32000, // 32kbps for improved audio quality (up from 20kbps)
        audioConstraints: {
          audio: {
            echoCancellation: true,
            noiseSuppression: true,
            autoGainControl: true,
            channelCount: 1,
            sampleRate: 48000,
            // Enhanced audio quality constraints
            latency: 0.01, // Low latency mode (10ms)
            // Browser-specific optimizations (widely supported)
            googEchoCancellation: true, // Google Chrome echo cancellation
            googNoiseSuppression: true, // Google Chrome noise suppression
            googAutoGainControl: true, // Google Chrome auto gain control
            googHighpassFilter: true, // Remove low-frequency noise
            googTypingNoiseDetection: true, // Reduce keyboard typing noise
            googAudioMirroring: false, // Disable mirroring for better quality
            // Firefox specific
            mozEchoCancellation: true,
            mozNoiseSuppression: true,
            mozAutoGainControl: true,
            // Safari specific
            webkitEchoCancellation: true,
            webkitNoiseSuppression: true,
            webkitAutoGainControl: true
          }
        },
        edge: optimalEdges,
        // Increase connection timeout (default is 10 seconds)
        // This gives more time for device registration
        logLevel: 'warn' // Reduce console noise
      });

      device.audio.on("deviceChange", updateAllDevices.bind(device));

      // Device registration event handlers
      device.on("registered", () => {
        DialerServiceData.setDeviceStatus("registered");
      });

      device.on("error", err => {
        console.error("Twilio Device Error:", err);
        const errorCode = err?.code || err?.message?.match(/\((\d+)\)/)?.[1];
        
        // Handle specific device errors
        if (errorCode === "31000" || errorCode === 31000) {
          console.error("Device registration timeout - attempting to reinitialize");
          // Try to refresh token and reinitialize
          setTimeout(async () => {
            try {
              await DialerServiceData.getDailerToken(selectedChannel === "channel1");
              const newTokenObj = DialerServiceData.dialerTokenObj;
              if (newTokenObj?.capabilityToken) {
                configureTwilioDevice(newTokenObj);
              }
            } catch (e) {
              console.error("Failed to reinitialize device after timeout:", e);
            }
          }, 2000);
        }
        
        // Only call endCall if there's an active call
        if (dialerOption?.call) {
          endCall();
        }
      });

      // Token refresh handling
      const refreshTwilioToken = async () => {
        try {
          await DialerServiceData.getDailerToken(selectedChannel === "channel1");
          const newTokenObj = DialerServiceData.dialerTokenObj;
          const newDecryptedToken = getDecryptCapabilityToken(
            newTokenObj?.capabilityToken
          );
          if (newDecryptedToken && device) {
            device.updateToken(newDecryptedToken);
          }
        } catch (e) {
          console.error("Failed to refresh Twilio token:", e);
        }
      };

      device.on("tokenWillExpire", refreshTwilioToken);
      device.on("tokenExpired", refreshTwilioToken);

      // Register the device
      try {
        await device.register();
      } catch (e) {
        console.error("Failed to register device:", e);
      }
      
      return device; // Return device for pre-registration check
    }
    return null;
  };

  const getTokenObjAndInitTwilioConfig = async () => {
    if (DialerServiceData.dialerTokenObj) {
      setTokenObj(DialerServiceData.dialerTokenObj);
      try {
        const configuredDevice = await configureTwilioDevice(DialerServiceData.dialerTokenObj);
        
        // Hide loader once device is configured (don't wait for registration)
        setLoader(false);
        
        // Pre-register device in background (non-blocking)
        if (configuredDevice) {
          // Wait a bit for device to initialize, then check registration status
          setTimeout(() => {
            if (configuredDevice && configuredDevice.state !== "registered") {
              configuredDevice.register().catch(err => {
                console.warn("Pre-registration failed, will register on call:", err);
              });
            }
          }, 500);
        }
      } catch (err) {
        console.error("Error configuring Twilio device:", err);
        // Hide loader even on error to prevent UI from being stuck
        setLoader(false);
      }
    } else {
      // No token yet, but hide loader after reasonable timeout
      setTimeout(() => setLoader(false), 2000);
    }
  };

  const checkPhonePresentOrEdited = () => {
    if (phone?.[0]) {
      return phoneNoEdited;
    }
    return true;
  };

  const getAndSaveRandomId = () => {
    const randomId = Utils.generateRandomNumber();
    setRandomId(randomId);
    return randomId;
  };

  const showCallLogsSliderCard = () => {
    // Show call log when:
    // - Call is not active (!dialerOption.call)
    // - Call logs state is true (callLogs)
    // - Either dialerLogAfterCallEnd is enabled OR there's a valid call attempt
    const result = (
      !dialerOption.call &&
      callLogs &&
      (
        dialerLogAfterCallEnd ||
        dialerLogsPopupState.dialerLogSettings.callSid ||
        userEndedCall ||
        callAttempted
      )
    );
    
    return result;
  };

  useEffect(() => {
    setDialerCredits(userDetail.userFeatureFlag?.dialerCredits || 0);
  }, [userDetail.userFeatureFlag.dialerCredits]);

  useEffect(() => {
    if (DialerServiceData?.dialerDefaultNo !== "purchaseNumber") {
      setDefaultNo(DialerServiceData.dialerDefaultNo);
    }
  }, [DialerServiceData.dialerDefaultNo]);

  useEffect(() => {
    setDialerOption({ ...dialerOption, ...DialerServiceData?.dialerOption });
  }, [DialerServiceData.dialerOption]);

  useEffect(() => {
    getTokenObjAndInitTwilioConfig().catch(err => {
      console.error("Error initializing Twilio config:", err);
    });
  }, [DialerServiceData.dialerTokenObj]);

  useEffect(() => {
    setCallLog(DialerServiceData.dialerCallLogs);
  }, [DialerServiceData.dialerCallLogs]);

  useEffect(() => {
    getTokenObjAndInitTwilioConfig().catch(err => {
      console.error("Error initializing Twilio config:", err);
    });
    hideIntercomChat();
    return () => {
      dialerLogsPopupState.setDialerNumber("");
      setRecordingActivated(false);
      try {
        if (device) {
          device.destroy();
          device = null;
        }
      } catch (e) {
        console.error("Error destroying Twilio device", e);
      }
    };
  }, []);

  useEffect(() => {
    setPhoneNo(getNumberList());
  }, [mobilePhone, phone, otherPhone, selectedNumber]);

  useEffect(() => {
    dialerLogsPopupState.setDialerNumber(phoneNo);
  }, [phoneNo]);

  return (
    <>
      <div
        className={`dialerServiceCardSection ${
          slideAnimation ? "slideInFromBottom" : "slideOutToBottom"
        }`}
        style={{ right: isContactCard ? "360px" : "0px" }}
      >
        <div className="dialerServiceCard">
          <SliderHeader
            isCloseBtnEnabled={closeBtnEnabled}
            title="Call"
            logo={false}
            closeDialerCard={closeDialerCard}
            isBackArrow={isBackArrow}
            backArrowCbk={backArrowCbk}
            toggleDropdown={toggleDropdown}
            setToggleDropDown={setToggleDropDown}
          />
          <div style={{ display: toggleDropdown ? "block" : "none" }}>
            {!dialerOption?.call && (
              <ContactInfo contact={data} showRoundedCircle={true} />
            )}
            {!callLogs && !dialerLogsPopupState?.showEditCallLogs && (
              <section className="dialerInformationArea">
                <DialerKeypad
                  contact={data}
                  cbkNoUpdate={getPhoneNo}
                  activeConnection={activeConnection}
                  isRecordingActivated={isRecordingActivated}
                  selectedNumber={selectedNumber}
                />
                {!loader && (
                  <DialerButton
                    cbk={dialerServiceMultiEvent}
                    activeConnection={activeConnection}
                    callSid={dialerLogsPopupState.dialerLogSettings.callSid}
                    isRecordingActivated={isRecordingActivated}
                    setRecordingActivated={setRecordingActivated}
                  />
                )}
                {loader && <DialerButtonLoader />}
                <DialerDefaultNumber calling={dialerOption?.call} />
                {userDetail.userFeatureFlag?.callingChannelEnabled !== false && (
                  <DialerChannelSelector
                    selectedChannel={selectedChannel}
                    onChannelChange={async channel => {
                      setSelectedChannel(channel);
                      // Refresh token with new channel setting
                      if (!dialerOption?.call) {
                        await DialerServiceData.getDailerToken(
                          channel === "channel1"
                        );
                        const newTokenObj = DialerServiceData.dialerTokenObj;
                        if (newTokenObj) {
                          setTokenObj(newTokenObj);
                          await getTokenObjAndInitTwilioConfig();
                        }
                      }
                    }}
                    calling={dialerOption?.call}
                  />
                )}
                <DialerCredits
                  calling={dialerOption.call}
                  dialerCredits={dialerCredits?.toFixed(2) || 0}
                />
              </section>
            )}
            {callLogs &&
              !dialerLogAfterCallEnd &&
              !dialerLogsPopupState?.showEditCallLogs && (
                <>
                  <DialerKeypad
                    contact={data}
                    cbkNoUpdate={getPhoneNo}
                    activeConnection={activeConnection}
                    isRecordingActivated={isRecordingActivated}
                  />
                  {!loader && (
                    <DialerButton
                      cbk={dialerServiceMultiEvent}
                      activeConnection={activeConnection}
                      callSid={dialerLogsPopupState.dialerLogSettings.callSid}
                      isRecordingActivated={isRecordingActivated}
                      setRecordingActivated={setRecordingActivated}
                    />
                  )}
                  {loader && <DialerButtonLoader />}
                  <DialerDefaultNumber calling={dialerOption?.call} />
                  {userDetail.userFeatureFlag?.callingChannelEnabled !== false && (
                    <DialerChannelSelector
                      selectedChannel={selectedChannel}
                      onChannelChange={async channel => {
                        setSelectedChannel(channel);
                        // Refresh token with new channel setting
                        if (!dialerOption?.call) {
                          await DialerServiceData.getDailerToken(
                            channel === "channel1"
                          );
                          const newTokenObj = DialerServiceData.dialerTokenObj;
                          if (newTokenObj) {
                            setTokenObj(newTokenObj);
                            await getTokenObjAndInitTwilioConfig();
                          }
                        }
                      }}
                      calling={dialerOption?.call}
                    />
                  )}
                  <DialerCredits
                    calling={dialerOption.call}
                    dialerCredits={dialerCredits?.toFixed(2) || 0}
                  />
                </>
              )}
            {(showCallLogsSliderCard() ||
              dialerLogsPopupState.showEditCallLogs) && (
              <DialerLogsAfterCallEnd
                contactName={Utils.getName(firstName, lastName, name)}
                phoneNumber={phoneNo}
                contactId={cId || contactId}
                closeDialer={closeDialerCard}
                isContactHasNo={checkPhonePresentOrEdited()}
                randomId={randomId}
                callSid={dialerLogsPopupState.dialerLogSettings.callSid}
                disableToggle={pageType === "calls"}
              />
            )}
            {showUpgradeCredits && (
              <DialerUpgradeCreditsPopup hide={hideUpgrade} />
            )}
          </div>
        </div>
      </div>
    </>
  );
});

export default DialerSliderCard;
export { DialerSliderCard };
